import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { clx } from "../../../utils/Helpers";
import "./UIAccordion.scss";

const UIAccordion = ({
  title,
  hasCustomizeTitle,
  children,
  action,
  defaultExpanded,
  expanded,
  onChange,
  id,
  expandedIconSize,
  classNames,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  const isControlled = expanded !== undefined;
  const isExpanded = isControlled ? expanded : internalExpanded;
  const accordionId = id || "ui-accordion";

  const handleChange = (event, nextExpanded) => {
    if (!isControlled) {
      setInternalExpanded(nextExpanded);
    }
    onChange?.(nextExpanded, event);
  };

  return (
    <MuiAccordion
      className={clx("ui-accordion", classNames.root)}
      expanded={isExpanded}
      onChange={handleChange}
      disableGutters
      elevation={0}
    >
      <AccordionSummary
        className={clx("ui-accordion__header", classNames.summary)}
        expandIcon={<ExpandMore fontSize="small" sx={{ fontSize: expandedIconSize }} />}
        aria-controls={`${accordionId}-content`}
        id={`${accordionId}-header`}
      >
        <div className={clx("ui-accordion__header-content", classNames.header)}>
          {
            hasCustomizeTitle ?  title : (
              <Typography className={clx("ui-accordion__title", classNames.title)}>
                {title}
              </Typography>
            )
          }
          {action && (
            <div
              className={clx("ui-accordion__action", classNames.action)}
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
            >
              {action}
            </div>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={clx("ui-accordion__body", classNames.body)}>
        {children}
      </AccordionDetails>
    </MuiAccordion>
  );
};

UIAccordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  hasCustomizeTitle: PropTypes.bool,
  expandedIconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node.isRequired,
  action: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string,
  classNames: PropTypes.shape({
    root: PropTypes.string,
    summary: PropTypes.string,
    header: PropTypes.string,
    title: PropTypes.string,
    action: PropTypes.string,
    body: PropTypes.string,
  }),
};

UIAccordion.defaultProps = {
  action: null,
  expandedIconSize: 20,
  hasCustomizeTitle: false,
  defaultExpanded: false,
  expanded: undefined,
  onChange: undefined,
  id: undefined,
  classNames: {},
};

export default UIAccordion;
